import script from "./workflowOppEditor.vue?vue&type=script&lang=js"
export * from "./workflowOppEditor.vue?vue&type=script&lang=js"

import "./workflowOppEditor.vue?vue&type=style&index=0&id=ada9b6d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada9b6d4"]])

export default __exports__